// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a029dc61","598":"95713889","703":"33f40c44"}[chunkId] + ".chunk.js";
};